<style lang="less" scoped>
@import '../../../style/common/variable';
.relatedInfo{position: relative; width: 810px;height: 200px;font-family: AlibabaPuHuiTi-Medium;padding: 0px;}
.left{float: left;}
.left img{vertical-align: middle;margin-left: -5px;margin-right: 5px;}
.left span{font-size: 18px;font-weight: 600;}
.right{float: right;}
.right span{font-size: 16px;font-weight: 600;color: rgb(49, 49, 49);text-decoration:underline}
.right span:hover{color: #13569e;cursor: pointer;}
.Box{position: absolute;top:30px;left: 0px;width: 830px;height: 160px;padding: 0px;cursor: pointer;}
ul{list-style: none;display: flex;margin-left: -42px;}
li{width: 150px;height: 160px;margin-right: 20px;}
li:hover{box-shadow: 0px 0px 3px 1px rgb(240, 239, 239);}
li:hover img {opacity:0.8;}
.pic{width: 150px;height: 110px;border:1px solid #f2f2f2;overflow:hidden;}
.title{font-size: 14px;width: 150px;height: 40px;margin:0px;overflow:hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;}
.title:hover{color: #13569e;}
.title{height: 32px;line-height: 16px; overflow:hidden;}
.title::after{content: ' ... ';}
.current{display: none;}

/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .left{margin-left: .1rem;
    span{font-size: .16rem}
  }
  .relatedInfo{height: 3.5rem; width: 97vw;}
  .Box{
    ul{flex-wrap: wrap;width: 100vw;justify-content: space-around;
      li{width: 40vw; margin-right: 0;
        .title{width: 40vw}
        img{width: 40vw}
      }
    }
  }
}
</style>

<!--何宽 2021.6.13
    该组件使用场景：横向展示五张图片及其名称，点击右上角，依次往后更换五张图片的信息-->
<template>
  <div class="relatedInfo">
    <div class="left">
      <span><slot name="icon"></slot></span>
      <span><slot name="type"></slot></span>
    </div>
    <div class="right">
      <span class="swap-R" @click="changePic"><i><slot name="description"></slot></i></span>
    </div>
    <div class="Box">
      <ul>
        <li v-for="(item,index) in (isMobile ? datalist.slice(0, 4) : datalist)" :key="index" @click="clickReInfo(item)">
          <img class="pic" :src="item.pic">
          <p class="title"> {{ item.title }} </p>
        </li>
      </ul>
      <p class="current"> {{ current }} </p>
    </div>
  </div>
</template>

<script>

export default {
  props: ['relatedInfoList'],
  data()
  {
    return {
      current: 0,  // 点击换一换的次数
      datalist: [], // 临时存储5张图片
      isMobile: this.isMobileFunc()
    }
  },
  watch:
  {
    relatedInfoList:
    {
      handler(nval, oval)
      {
        this.changePic()
      }
    }
  },
  updated()
  {
    var oList = document.querySelectorAll('.title')
    var alltableArray = Array.prototype.slice.call(oList)
    alltableArray.forEach(function(item)
    {
      var oHeight = item.height
      if ((oHeight / 15) > 2)
        item.className = 'title'
    })
  },
  methods: {
    // 用户设备的判断
    isMobileFunc()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    // 换一换
    changePic()
    {
      this.current += 1
      if (this.relatedInfoList.length - this.current * 5 > 0)
      {
        for (let i = 0; i < 5; i++)
          this.datalist[i] = this.relatedInfoList[i + (this.current - 1) * 5]
      }
      else
      {
        if (this.relatedInfoList.length - this.current * 5 > -5)
        {
          for (let i = 0; i < this.relatedInfoList.length - (this.current - 1) * 5; i++)
            this.datalist[i] = this.relatedInfoList[i + (this.current - 1) * 5]
          for (let i = this.relatedInfoList.length - (this.current - 1) * 5; i < 5; i++)
            this.datalist[i] = this.relatedInfoList[i - 1]
        }
        else
        {
          for (let i = 0; i < 5; i++)
            this.datalist[i] = this.relatedInfoList[i]
          this.current = 0
        }
      }
    },
    //点击图片或内容，将 整个对象 传递给父组件
    clickReInfo(item)
    {
      this.$emit('clickReInfo', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/RelatedInfo.vue